import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// TypeScript-enabled entry point for Antasis Ecosystem SSO Dashboard
// Ensures type-safe React initialization and component rendering
const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found in DOM');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
